import React, { Component, PropsWithChildren } from 'react';

export interface ITabItemProps extends PropsWithChildren<{}> {
    onClick?: (index?: number) => void;
    index?: number;
    active?: boolean;
    isHidden?: boolean;
}

export default class TabItem extends Component<ITabItemProps, {}> {
    constructor(props: ITabItemProps) {
        super(props);
    }

    public onTabClick(index?: number) {
        if (this.props.onClick) {
            this.props.onClick(index);
        }
    }

    public render() {
        const { isHidden, index, active, children } = this.props;
        return (
            <li
                key={index}
                className={`header-item ${isHidden ? 'hidden' : ''}`}
                onClick={() => {
                    this.onTabClick(index);
                }}
            >
                <div className={`tab-title ${active ? 'active' : ''}`}>
                    {children}
                    <div className="active-border"></div>
                </div>
            </li>
        );
    }
}
